const FLYTODAY_UPDATED = (state, FlyToDay) => {
  state.FlyToDay = FlyToDay
}

export default {
  FLYTODAY_UPDATED
}
